import { Outlet } from 'react-router-dom'
import SubgroupLeaderBottomNav from '../components/SubgroupLeaderBottomNav'

export default function SubgroupLeaderLayout() {
  return (
    <>
      <Outlet />
      <SubgroupLeaderBottomNav />
    </>
  )
}